import AOS from 'aos';
import 'aos/dist/aos.css';
import isCurrentMq from './isCurrentMq.js';

/**
 * aos.js初期化
 */
const initAOS = () => {
    const mq = isCurrentMq();

    // 発火位置の設定
    let offset = 100; //SP
    if (mq === 'lg' || mq === 'xl') {
        offset = 250; //PC
    }

    AOS.init({
        offset: offset,
        once: true,
        delay: 0,
        duration: 1000,
    });
}

export default initAOS